import { useState } from "react";
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { deactivateUser } from "../../../redux/clientPortal/clientPortalslice";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  fetchPartnerData,
  setClientActiveStatus,
  setPartnerActiveStatus,
} from "../../../redux/clientPortal/clientPartnerSlice";

interface DeleteAccountPopupProps {
  open: boolean;
  idToUse: string;
  customerId: string;
  targetType: "client" | "partner" | null;
  onClose: () => void;
  notify: any;
}

function DeleteAccountPopup({
  open,
  idToUse,
  customerId,
  targetType,
  onClose,
  notify,
}: DeleteAccountPopupProps) {
  const dispatch: AppDispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDeactivate = async () => {
    if (!idToUse || !targetType) return;

    setIsSubmitting(true);
    try {
      const resultAction = await dispatch(
        deactivateUser({ customerId: idToUse })
      );
      const result = unwrapResult(resultAction);
      notify(result.message, "", "success");
      if (targetType === "client") {
        dispatch(setClientActiveStatus(false));
      } else if (targetType === "partner") {
        dispatch(setPartnerActiveStatus(false));
        // 3. Refresh partner data
        dispatch(fetchPartnerData(idToUse));
      }

      onClose();
    } catch (err: any) {
      console.error("Error deactivating account:", err);
      notify(err.message || "Error deactivating account", "", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!targetType || !customerId) return null;

  return (
    <Dialog
      open={open}
      onOpenChange={(_, data) => !data.open && onClose()}
      modalType="modal"
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Deactivate{" "}
            {targetType.charAt(0).toUpperCase() + targetType.slice(1)} Account
            <Button
              appearance="subtle"
              icon={<Dismiss24Regular />}
              onClick={onClose}
              disabled={isSubmitting}
            />
          </DialogTitle>
          <DialogContent>
            Are you sure you want to deactivate the {targetType} account? This
            action cannot be undone.
            <div className="cp_group_buttons" style={{ margin: "10px 0" }}>
              <Button
                appearance="primary"
                className="asc-button-primary"
                onClick={handleDeactivate}
                disabled={isSubmitting}
                style={{ backgroundColor: "#d13438" }}
              >
                {isSubmitting ? "Deactivating..." : "Deactivate"}
              </Button>
              <Button
                appearance="outline"
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default DeleteAccountPopup;
